import { RoomMessage, RoomMessageType } from "../../proto/Global_pb";
import store from "../../store";
import { includes } from "lodash";

export const getFileResolution = (messageType: RoomMessage.AsObject["messageType"]): Promise<{ width: number; height: number }> => {
  return new Promise((resolve) => {
    const state = store.getState();
    let file = state.messenger.messengerAttachment && state.messenger.messengerAttachment[0];
    const rawFile = file?.getRawFile();
    const url = rawFile && URL.createObjectURL(rawFile);
    const defaultResolution = { width: 0, height: 0 };
    if (url === undefined) {
      return resolve(defaultResolution);
    }
    if (includes([RoomMessageType.IMAGE, RoomMessageType.IMAGE_TEXT, RoomMessageType.GIF, RoomMessageType.GIF_TEXT], messageType)) {
      const img = new Image();
      img.onload = () => {
        resolve({
          width: img.naturalWidth || img.width,
          height: img.naturalHeight || img.height,
        });
        URL.revokeObjectURL(url);
      };
      img.src = url;
    } else if (includes([RoomMessageType.VIDEO, RoomMessageType.VIDEO_TEXT], messageType)) {
      const video = document.createElement("video");
      video.addEventListener("loadedmetadata", () => {
        resolve({
          width: video.videoWidth,
          height: video.videoHeight,
        });
      });
      video.src = url;
    }
    resolve(defaultResolution);
  });
};
